import { createContext } from 'react'
import type { Database } from 'web/db';

export const DatabaseContext = createContext<Database|null>(null);
